<div class="transport-registration-target-station-selection">
  <app-centered-scrollable-content>
    <div class="stationa">
      @for (l of availableTargetStations; track l) {
        <div class="station">
          <app-tapable-terminal-card [size]="cardSize" (click)="selectTargetStation(l)">
            <sc-flex centered vertical fitHeight>
                {{ l.name }}
            </sc-flex>
          </app-tapable-terminal-card>
        </div> 
      }
    </div>
  </app-centered-scrollable-content>
</div>
